import React from 'react'
import BannerImage from './email-builder/elements/BannerImage'
import Body from './email-builder/elements/Body'
import ButtonLink from './email-builder/elements/ButtonLink'

export interface ICampaignTemplateProps {
  text: string
  coverImageSrc?: string | null
  coverImageBase64?: string | null
  buttonText?: string | null
  buttonLink?: string | null
}

export const CampaignTemplate: React.FC<ICampaignTemplateProps> = (props) => {
  const { text, coverImageSrc, coverImageBase64, buttonText, buttonLink } =
    props

  const imageSrc = coverImageSrc || coverImageBase64

  // fix align
  const __html = text
    .replace(/<(\w+) class="ql-align-(\w+)">/g, '<$1 style="text-align: $2">')
    .replace(/&amp;/g, '&')
    .replace(/<img/g, '<img style="max-width: 100%"')

  return (
    <>
      {imageSrc && <BannerImage imageSrc={imageSrc} />}
      <Body>
        <div dangerouslySetInnerHTML={{ __html }} />
        {buttonText && buttonLink && (
          <ButtonLink link={buttonLink} text={buttonText} />
        )}
      </Body>
    </>
  )
}
